<div class="lib-content">
  <content class="content">
    <div class="lib-container">
      <ng-container *ngIf="isWorkFlowPage()">
        <div class="faq-link-container">
          <a (click)="toggleFaqPanel($event)" class="faq-link">FAQ</a>
        </div>
        <div class="help-link-container">
          <a (click)="openSectionHelpDocument()" class="help-link">Help</a>
        </div>
        
        <app-faq-panel
          [isOpen]="isFaqPanelOpen"
          [currentPage]="getcurrentUrlSegment()"
          (closePanel)="closeFaqPanel()">
        </app-faq-panel>
      </ng-container>
      
      <div>
        <div class="lib-menu" [ngClass]="{'d-none': isListPage()}" >
          <app-side-bar></app-side-bar>
        </div>
       <ng-container  *ngIf="isProgressPage()">
        <app-progress-bar></app-progress-bar>
        </ng-container>
        <div [ngClass]="{
          'lib-body': currrWidth > 1200,
          'lib-body-fixed': currrWidth <= 1200,
          'lib-body-full-width': isListPage()
        }">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </content>
</div>